import { Alert, Alignment, Button, FormGroup, Icon, NonIdealState } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IEmpresa, newEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { SpedImportTxt, SpedImportTxtStore } from "../../stores/sped/SpedImportTxtStore";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { formatCnpj } from "../../utils";
import Dropzone from "react-dropzone";
import { toast } from "react-toastify";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import moment from "moment";
import { getTag } from "../utils/getStatus";
import { Pager } from "../utils/Pager";
import ReactJson from "react-json-view";
import LoadingModal from "../loading/LoadingModal";

@observer
export class SpedPlanilhaPage extends React.Component<{}, {}> {

  obs = observable({
    importarTxts: false as boolean,
    selectEmpresa: newEmpresa() as IEmpresa,
    current_page: 1 as number,
    selectedEmpresaImport: newEmpresa() as IEmpresa,
    open_detalhes: false as boolean,
    tarefa: {} as any
  })

  constructor(props: any) {
    super(props);
    AppStore.setTitle("Importação SPED");
  }

  async componentDidMount() {
    AppStore.setTitle("Importação SPED");
    SpedImportTxtStore.handleConsulta(1, "");
  }

  onCloseImportarXmls() {
    SpedImportTxtStore.obs.importarTxts = false
    this.obs.selectedEmpresaImport = newEmpresa()
  }

  dateFormatter(cell, row) {
    return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " ás " + moment(cell).add(3, "hour").format("HH:mm");
  };

  cnpjFormatter(cell, row) {
    if (row.cnpj) {
      let emp = EmpresaStore.getByCnpj(row.cnpj);
      if (emp) {
        return `${emp.razao_social.substring(0, 30)} - ${formatCnpj(row.cnpj)}`
      }
    }

    return ""
  };

  handleBuscaTarefas = async (empresa) => {

    this.obs.selectEmpresa = empresa

    await SpedImportTxtStore.handleConsulta(1, this.obs.selectEmpresa.cnpj);

  };

  handleChangePage = async (page) => {

    this.obs.current_page = page

    await SpedImportTxtStore.handleConsulta(page, this.obs.selectEmpresa.cnpj);

  };

  statusFormatter(cell, row) {

    return getTag(row.status, "calculo");

  }

  handleFileDropEntrada = async (files: any) => {
    let niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];

    if (niveis_acesso.indexOf("i1") == -1) {
      toast.warning("Você não possui permissão para importar arquivo SPED", {});
      return
    }

    if (this.obs.selectedEmpresaImport.razao_social == "") {
      toast.warning("Você precisa selecionar uma Empresa", {});
      return
    }

    var data = new FormData();

    data.append("file", files[0])
    data.append("cnpj", this.obs.selectedEmpresaImport.cnpj)

    await SpedImportTxtStore.handldeCreateTaskImport(data);

    this.obs.current_page = 1;

    SpedImportTxtStore.handleConsulta(1, this.obs.selectEmpresa.cnpj);

  };

  handleFileDropRejected = async (files: any) => {
    if (files.length > 1) {
      toast.warning("Apenas um arquivo por vez é liberado para importação.", {});
      return;
    }

    toast.warning("Arquivo inválido, é aceito somente arquivos .txt", {});
    return;
  };

  render() {
    function fileFormatter(cell, row) {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            disabled={row.status != 2}
            onClick={() => SpedImportTxtStore.handleDownloadArquivoRelatorio(row.relatorio_id, row.cnpj, row.format)}
          >
            <img src="/images/download.svg" />
          </MDBBtn>
        </>
      );
    }

    function buttonFormatterDetalhes(cell, row) {
      return (
        <>
          <MDBBtn disabled={row.status != 3} color="default" rounded size="sm" onClick={(e) => handleViewDetalhes(row)} >
            <img src="/images/view.png" width="18px" />
          </MDBBtn>
        </>
      );
    }

    function dateFormatter(cell, row) {
      return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " ás " + moment(cell).add(3, "hour").format("HH:mm");
    };

    function cnpjFormatter(cell, row) {
      if (row.cnpj) {
        let emp = EmpresaStore.getByCnpj(row.cnpj);
        if (emp) {
          return `${emp.razao_social.substring(0, 30)} - ${formatCnpj(row.cnpj)}`
        }
      }

      return ""
    };

    function statusFormatter(cell, row) {

      return getTag(row.status, "calculo");

    }

    const handleViewDetalhes = async (row) => {

      this.obs.tarefa = row

      this.obs.open_detalhes = true

    };

    let empresaTextImport = this.obs.selectedEmpresaImport.razao_social != ""
      ? `${this.obs.selectedEmpresaImport.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectedEmpresaImport.cnpj)})`
      : "Selecione uma empresa";

    let empresaText = this.obs.selectEmpresa.cnpj != ""
      ? `${this.obs.selectEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresa.cnpj)})`
      : "Selecione uma empresa";

    return (
      <>
        <MDBRow>

          <MDBCol md="4">
            <FormGroup className="empresaSelect" label="Empresa">
              <EmpresaSelect
                items={EmpresaStore.sortedEmpresas}
                itemRenderer={renderEmpresa}
                itemPredicate={filterEmpresa}
                onItemSelect={(e: IEmpresa) => this.handleBuscaTarefas(e)}
                inputProps={{ placeholder: "Filtrar uma empresa" }}
              >
                <Button
                  text={empresaText || "Selecione uma empresa"}
                  alignText={Alignment.LEFT}
                  rightIcon={
                    this.obs.selectEmpresa.cnpj ? (
                      <Icon
                        className="clear-icon-empresa"
                        icon="cross"
                        onClick={(ev) => {
                          ev.stopPropagation();
                          this.handleBuscaTarefas(newEmpresa());
                        }}
                      />
                    ) : (
                      <Icon icon="double-caret-vertical" style={{ padding: 5 }} />
                    )
                  }
                />
              </EmpresaSelect>
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <MDBBtn className="btnDefault btnBuscarNfe mt25" onClick={() => this.handleChangePage(1)}>
              Buscar
            </MDBBtn>
          </MDBCol>

        </MDBRow>
        <MDBRow>
          <MDBCol md="12">
            <MDBBtn
              className="btnDefault btnImportarXmls"
              onClick={() => {
                this.obs.selectedEmpresaImport = newEmpresa();
                SpedImportTxtStore.obs.importarTxts = true;
              }}
              style={{ float: "left" }}
              data-tut="importar_xmls"
            >
              Importar SPED
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol md="12">
            <BootstrapTable className="TableDefaultImport" data={SpedImportTxtStore.obs.tasks_sped} style={{ marginTop: 10 }}>
              <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%"> # </TableHeaderColumn>
              <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="20%">Data</TableHeaderColumn>
              <TableHeaderColumn dataFormat={cnpjFormatter} width="30%">Empresa</TableHeaderColumn>
              <TableHeaderColumn dataFormat={statusFormatter} width="25%">Status</TableHeaderColumn>
              <TableHeaderColumn dataFormat={fileFormatter} width="10%">Arquivo</TableHeaderColumn>
              <TableHeaderColumn dataFormat={buttonFormatterDetalhes} width="10%">Detalhes</TableHeaderColumn>
            </BootstrapTable>
          </MDBCol>
        </MDBRow>

        <Alert
          confirmButtonText="Fechar"
          isOpen={SpedImportTxtStore.obs.importarTxts}
          onClose={() => this.onCloseImportarXmls()}
          canOutsideClickCancel={true}
        >
          <h2 className="titleSEFAZ">Importações</h2>
          <MDBRow>
            <MDBCol md="12">
              <FormGroup className="empresaSelectImport" label="Empresa">
                <EmpresaSelect
                  items={EmpresaStore.sortedEmpresas}
                  itemRenderer={renderEmpresa}
                  itemPredicate={filterEmpresa}
                  onItemSelect={(e: IEmpresa) => this.obs.selectedEmpresaImport = e}
                  inputProps={{ placeholder: "Filtrar uma empresa" }}
                >
                  <Button
                    text={empresaTextImport}
                    rightIcon="double-caret-vertical"
                    alignText={Alignment.LEFT}
                  />
                </EmpresaSelect>
              </FormGroup>
            </MDBCol>

          </MDBRow>

          {this.obs.selectedEmpresaImport.razao_social == "" ?
            <div>
              <NonIdealState
                icon="box"
                title="Selecione a empresa para a qual deseja realizar a importação."
              />
            </div>
            :
            <div>
              <Dropzone
                accept={{
                  "files/txt": [".txt"],
                }}
                maxFiles={1}
                multiple={false}
                onDropAccepted={this.handleFileDropEntrada}
                onDropRejected={this.handleFileDropRejected}
              >
                {({ getRootProps, getInputProps }) => (
                  <>
                    <div {...getRootProps()} style={{ marginBottom: 20 }}>
                      <input {...getInputProps()} />
                      <Button
                        icon="upload"
                        text="Selecionar SPED para upload"
                        className="btn-file btnDefault noMargin"
                      />
                    </div>

                    <div {...getRootProps()} className="nz-upload-box">
                      <input {...getInputProps()} />
                      <Icon icon="upload" iconSize={60} />
                      <span style={{ marginLeft: 20 }}>
                        Arraste o arquivo para importar.{" "}
                      </span>
                    </div>
                  </>
                )}
              </Dropzone>
            </div>

          }

        </Alert>

        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.open_detalhes}
          onClose={() => this.obs.open_detalhes = false}
          onConfirm={() => this.obs.open_detalhes = false}
          canOutsideClickCancel={true}
          className="AlertErrorSped"
      >
          <h2 className="titleSEFAZ">Erros</h2>
          <MDBCol md="12">
              {this.obs.tarefa.error &&
                  <div className="errosSped">
                      <BootstrapTable className="nomeArquivos" data={[this.obs.tarefa]} hover>
                          <TableHeaderColumn dataField='id' isKey={true} hidden width='1%'>#</TableHeaderColumn>
                          <TableHeaderColumn dataField='error' width='100%'></TableHeaderColumn>
                      </BootstrapTable>
                  </div>
              }
          </MDBCol>
      </Alert>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.current_page}
            totalCount={SpedImportTxtStore.obs.length_tasks_sped}
            pageSize={15}
            onPageChange={(page) =>
              this.handleChangePage((page))
            }
          />
        </div>

          <LoadingModal open={SpedImportTxtStore.obs.loadingImport} onClose={() => SpedImportTxtStore.obs.loadingImport = false} title={"Importando arquivo"} />
          <LoadingModal open={SpedImportTxtStore.obs.loading} onClose={() => SpedImportTxtStore.obs.loading = false} title={"Baixando arquivo"} />
       
      </>

    )
  }
}

export default SpedPlanilhaPage;
